module.exports = __webpack_public_path__ + "assets/img/fontions_ged.0af2ba4c.jpg";